import React from 'react'

interface IcChevronProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  style?: React.CSSProperties
  direction?: 'up' | 'down'
}

const IcChevron: React.FC<IcChevronProps> = ({
  width = '17px',
  height = '17px',
  style,
  direction = 'down',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        flexShrink: 0,
        rotate: direction === 'up' ? '180deg' : '0deg',
        ...style,
      }}
      {...props}
    >
      <path
        d="M4 7.18443L8.5 11.5L13 7.18443"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcChevron
